import { SupportedMarketKey } from '@nxt-insurance/constants'

import type { Choice, TransformedNoContentOption } from '@flows/core/types/stepContentTypes'

const commonOptions: TransformedNoContentOption[] = [
  {
    label: { type: 'translatableText', translationKey: 'sharedFlows_common:generic.inputs.male' },
    value: 'm',
  },
  {
    label: { type: 'translatableText', translationKey: 'sharedFlows_common:generic.inputs.female' },
    value: 'f',
  },
]

const diverseOption: TransformedNoContentOption = {
  label: { type: 'translatableText', translationKey: 'sharedFlows_common:generic.inputs.diverse' },
  value: 'd',
}

const genderOptionsMap = {
  [SupportedMarketKey.De]: [...commonOptions, diverseOption],
  [SupportedMarketKey.At]: [...commonOptions, diverseOption],
}

const gender = (market: SupportedMarketKey) =>
  ({
    type: 'choice',
    name: 'gender',
    options: genderOptionsMap[market],
  }) satisfies Choice<any, any>

export default gender
